import React, { Component } from 'react';
import Page from '../../../components/Page';
import AccountProgress from '../../../components/AccountProgress';
import { Link } from 'react-router-dom';
import { Button, Breadcrumb, Icon, Segment, Modal, Header, List, Responsive, Popup, Message, Form } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { get, post } from '../../../util/api';
import MyMenu from '../menu';
import _ from 'lodash';
import { withTranslation } from 'react-i18next';
// eslint-disable-next-line
import styled from 'styled-components/macro';

class Phones extends Component {
	phoneToDelete = null;

	state = {
		currentPhones: 0,
		totalPhones: 0,
		loading: true,
		imageLoad: true,
		phones: [],
		refreshBtn: false,
		selectedPhone: null,
		screen_ss: null,
		addBtnClickable: true,
		deleteBtnClicked: false,
		hoveredIndex: null,
		goToSubs: false,
		phoneLoading: false,
	};

	componentDidMount() {
		let { product } = this.props;
		let pid = product.id;

		this.mount = true;
		if (product.settings === null || !product.settings.subscription_package) {
			return this.setState({ loading: false });
		}
		get(`/max/listPhones/${pid}`)
			.then((res) => {
				if (res && res.success !== true) return;
				res = _.filter(res.maxes, (it) => (it.type === 'max' ? it.data : null));
				res = _.map(res, (it) => it.data);
				let currentPhones = res.length;
				let totalPhones = currentPhones;
				this.setState({ loading: false, phones: res, currentPhones, totalPhones });
			})
			.catch((err) => {
				console.error(err);
				this.setState({ loading: false });
			});
	}
	componentWillUnmount() {
		clearTimeout(this._sr);
	}
	loginMax = () => {
		let { token } = this.state;
		let { product } = this.props;
		this.setState({ loginLoading: true });
		post('/max/login', { max_token: token, product })
			.then((data) => {
				data = data.data;
				if (data.success === false) {
					this.setState({
						loginError: data.error,
						loginLoading: false,
					});
					return;
				}
				let phones = this.state.phones;
				this.setState({ phones, currentPhones: phones.length, addBtnClickable: this.state.totalPhones > phones.length, loginMaxModal: false });
				window.location.reload();
			})
			.catch((err) => console.log('err', err));
	};
	addNewPhone = () => {
		let { token } = this.state;
		let { product } = this.props;

		post('/max/addMax', { product, auth: { token } })
			.then((res) => {
				if (res.status !== 200) return;
				res = res.data;
				if (res.success === false) return;
				let phones = this.state.phones;
				let newPhone = {
					id: res.data.id,
					number: res.data.username,
					status: 'creating...',
				};
				phones.push(newPhone);
				this.setState({
					phones,
					currentPhones: phones.length,
					addBtnClickable: this.state.totalPhones > phones.length,
					selectedPhone: newPhone,
					createAccountModal: false,
				});
				window.location.reload();
			})
			.catch((err) => {
				console.log('err', err);
			});
	};
	openCreateModal = (id, status) => {
		this.setState({
			loginMaxModal: true,
			selectedPhoneId: id,
			selectedPhone: {
				id,
				status,
			},
		});
	};
	logoutPhone = (id, number, status) => {
		let { product } = this.props;
		let selectedPhone = id || (this.state.selectedPhone && this.state.selectedPhone.id);
		if (selectedPhone) {
			this.setState({ logoutLoading: true });
			post('/max/logout', { product, id: selectedPhone })
				.then(async (res) => {
					if (res.success) {
						this.setState({ logoutLoading: false });
						window.location.reload();
					} else {
						this.setState({ logoutLoading: false });
						console.error(res.error);
					}
					await this.componentDidMount();
				})
				.catch((err) => {
					console.log('res', err);
				});
		}
	};

	deletePhone = (id, number, status) => {
		this.phoneToDelete = { id, number, status };
		this.setState({ selectedPhone: null, deleteBtnClicked: true });
		window.location.reload();
	};

	closeDeleteButton = () => {
		this.setState({
			deleteBtnClicked: false,
			goToSubs: false,
			disabledModal: false,
			createAccountModal: false,
			loginMaxModal: false,
		});
	};

	handleDelete = () => {
		let phones = this.state.phones;
		this.setState({ deleteBtnClicked: false, phones, currentPhones: phones.length, addBtnClickable: this.state.totalPhones > phones.length });
	};
	openAddModal = () => {
		this.setState({ goToSubs: true });
	};
	selectedAccountWhenClicked = (id, number, status) => {
		this.setState({
			selectedPhone: {
				id,
				number,
				status,
			},
		});
	};
	handleFormChange = (e, { name, value }) => {
		this.setState({ [name]: value });
	};
	TableRow = (phonedata, index) => {
		let number = phonedata.number || phonedata.username;
		let id = phonedata.id;
		let status = phonedata.status;
		let icon, textColor;
		if (number) {
			icon = 'check';
			textColor = 'green';
			status = 'active';
		} else {
			icon = 'sign-in';
			textColor = 'orange';
			status = 'not-logged-in';
		}
		return (
			<List.Item
				key={index}
				active={this.state.selectedPhone && this.state.selectedPhone.id === id}
				style={{ padding: 0, paddingLeft: '0.5em', paddingRight: '0.5em' }}
			>
				<div
					css={`
						display: flex;
						align-items: center;

						.phone-line {
							display: flex;
							align-items: center;
							flex: 1;
							color: black;
							height: 30px;
							padding: 1.5em 0.5em;
						}
						.phone-id {
							width: 80px;
						}
						.phone-number {
							width: 200px;
						}
						.phone-status {
							margin-right: 20px;
							margin-left: auto;
							white-space: nowrap;
						}
					`}
				>
					<div
						className="phone-line"
						onClick={() => {
							status === 'loading'
								? console.log('loading')
								: status === 'active' || (status === 'idle' && number) || status === 'account-error'
								? this.selectedAccountWhenClicked(id, number, status)
								: this.openCreateModal(id, status);
						}}
					>
						<div className="phone-id" style={{ width: '110px' }}>
							<strong>id: {id}</strong>
						</div>
						<Responsive as="div" className="phone-number" minWidth={Responsive.onlyMobile.maxWidth - 1}>
							<Icon name="paper plane"></Icon> {number || 'New Account'}
						</Responsive>
						<div className="phone-status" style={{ color: textColor }}>
							<Icon name={icon} loading={status === 'loading'}></Icon>
							{status}
						</div>
					</div>
					{status !== 'disabled' ? (
						<div style={{ textAlign: 'center', color: 'white', whiteSpace: 'nowrap' }}>
							<Popup
								content="Logout"
								position="bottom right"
								trigger={
									<Button
										icon
										size="tiny"
										loading={this.state.selectedPhone && this.state.selectedPhone.id === id && this.state.logoutLoading}
										onClick={() => this.logoutPhone(id, number, status)}
									>
										<Icon name="sign-out"></Icon>
									</Button>
								}
							/>
						</div>
					) : null}
				</div>
			</List.Item>
		);
	};

	async refreshSubscription() {
		await get('/live/payment/refreshSubscription').then(this.setState({ phoneLoading: false }));
	}
	render() {
		const { t } = this.props;
		let { token } = this.state;
		if (this.state.loading)
			return (
				<Page
					header={
						<Breadcrumb size="big">
							<Breadcrumb.Section as={Link} to={`/settings`}>
								<Icon name="setting" />
								{t('settings')}
							</Breadcrumb.Section>
							<Breadcrumb.Divider icon="right chevron" />

							<Breadcrumb.Section as={Link} to={`/settings/integrations`}>
								{t('integrations')}
							</Breadcrumb.Section>
							<Breadcrumb.Divider icon={{ name: 'asterisk', loading: true }} />
						</Breadcrumb>
					}
					flex
				>
					<MyMenu activeItem="max">
						<Page.Loader />
					</MyMenu>
				</Page>
			);
		else if (!this.props.product.settings || !this.props.product.settings.subscription_package) {
			return (
				<Page
					header={
						<Breadcrumb size="big">
							<Breadcrumb.Section as={Link} to={`/settings`}>
								<Icon name="setting" />
								{t('settings')}
							</Breadcrumb.Section>
							<Breadcrumb.Divider icon="right chevron" />

							<Breadcrumb.Section as={Link} to={`/settings/integrations`}>
								{t('integrations')}
							</Breadcrumb.Section>
							<Breadcrumb.Divider icon="right chevron" />
							<Breadcrumb.Section>MAX API</Breadcrumb.Section>
						</Breadcrumb>
					}
					extra={
						<div className="ml-auto">
							<AccountProgress></AccountProgress>
						</div>
					}
					flex
				>
					<MyMenu activeItem="max">
						<Page.Wrap>
							<Segment>
								<div style={{ textAlign: 'center' }}>
									<div>
										<Icon size="big" name="dont"></Icon>
									</div>
									<h2>{t('instaClosedBeta')}</h2>
									<p>{t('joinClosedBeta', { mail: 'info@dialogtab.com' })}</p>
								</div>
							</Segment>
						</Page.Wrap>
					</MyMenu>
				</Page>
			);
		} else {
			let orderList = _.orderBy(this.state.phones, ['id'], ['asc']);
			return (
				<Page
					header={
						<Breadcrumb size="big">
							<Breadcrumb.Section as={Link} to={`/settings`}>
								<Icon name="setting" />
								{t('settings')}
							</Breadcrumb.Section>
							<Breadcrumb.Divider icon="right chevron" />

							<Breadcrumb.Section as={Link} to={`/settings/integrations`}>
								{t('integrations')}
							</Breadcrumb.Section>
							<Breadcrumb.Divider icon="right chevron" />
							<Breadcrumb.Section>MAX API</Breadcrumb.Section>
						</Breadcrumb>
					}
					extra={
						<div className="ml-auto">
							<AccountProgress></AccountProgress>
						</div>
					}
					flex
				>
					<MyMenu activeItem="max">
						<Page.Wrap>
							<Message info hidden={!this.state.clickMessage}>
								{this.state.clickMessage}
							</Message>
							<Message info hidden={!this.state.statusError}>
								{this.state.statusError}
							</Message>
							<Segment attached="top" color="orange" textAlign="center">
								{t('registeredAccounts')}
							</Segment>
							<Segment attached textAlign="center" style={{ padding: 5 }}>
								<Button
									onClick={this.state.addBtnClickable ? () => this.setState({ createAccountModal: true }) : this.openAddModal}
									fluid
									positive
								>
									<span style={{ marginRight: 5 }}>{t('addNewAccounts')}</span>
								</Button>
							</Segment>
							{this.state.phones && (
								<Segment
									attached="bottom"
									piled
									style={{
										padding: 5,
										maxHeight: '300px',
										overflowY: orderList.length > 6 ? 'scroll' : 'hidden',
										overflowX: 'hidden',
										marginBottom: '5px',
									}}
								>
									{this.state.phones.length ? (
										<List selection verticalAlign="middle">
											{_.map(orderList, (data, index) => this.TableRow(data, index))}
										</List>
									) : (
										<p style={{ textAlign: 'center' }}>{t('thereIsNoAccount')}</p>
									)}
								</Segment>
							)}

							<Message info hidden={!orderList.length}>
								<p>
									{t('logout')}: {t('logoutDesc', { query: 'MAX' })}
								</p>
							</Message>
							<Segment>
								<Header>MAX Bot</Header>
								<ol>
									<li>
										<p>MAX uygulamasında MasterBot'u açın ve yeni bir bot oluşturun.</p>
									</li>
									<li>
										<p>MasterBot size bir erişim token'ı (access token) verecek.</p>
									</li>
									<li>
										<p>Token'ı kopyalayıp aşağıdaki "{t('addNewAccounts')}" alanına yapıştırın.</p>
									</li>
								</ol>
							</Segment>
						</Page.Wrap>
						<Modal open={this.state.deleteBtnClicked} onClose={this.closeDeleteButton} style={{ width: 500 }}>
							<Header icon="dont" content="Disable the Selected Account" />
							<Modal.Content>
								<p>{t('sureDisableAccount')}</p>
							</Modal.Content>
							<Modal.Actions>
								<Button color="red" onClick={this.closeDeleteButton}>
									<Icon name="remove" /> {t('no')}
								</Button>
								<Button color="green" onClick={this.handleDelete}>
									<Icon name="checkmark" /> {t('yes')}
								</Button>
							</Modal.Actions>
						</Modal>
						<Modal open={this.state.goToSubs} onClose={this.closeDeleteButton} style={{ width: 500 }}>
							<Header icon="paper plane" content="MAX Limit" />
							<Modal.Content>
								<h4>{t('closedBetaContact')}</h4>
							</Modal.Content>
						</Modal>
						<Modal open={this.state.loginMaxModal} onClose={this.closeDeleteButton} style={{ width: 500 }}>
							<Header icon="paper plane" content={`${t('login')} MAX`} />
							<Message error hidden={!this.state.loginError} style={{ marginLeft: '20px', marginRight: '20px' }}>
								{this.state.loginError}
							</Message>
							<Modal.Content>
								<Form onSubmit={this.loginMax}>
									<Form.Input
										label={t('token')}
										placeholder={t('companyPagePlaceholder', { query: t('token') })}
										required
										name="token"
										value={token}
										onChange={this.handleFormChange}
									/>
									<Form.Group>
										<Form.Button style={{ marginLeft: 'auto' }} positive type="submit" loading={this.state.loginLoading}>
											<Icon name="checkmark" /> {t('login')}
										</Form.Button>
										<Form.Button color="red" onClick={this.closeDeleteButton}>
											<Icon name="x" /> {t('close')}
										</Form.Button>
									</Form.Group>
								</Form>
							</Modal.Content>
						</Modal>
						<Modal open={this.state.createAccountModal} onClose={this.closeDeleteButton} style={{ width: 500 }}>
							<Header icon="paper plane" content="Login MAX" />
							<Message error hidden={!this.state.loginError} style={{ marginLeft: '20px', marginRight: '20px' }}>
								{this.state.loginError}
							</Message>
							<Modal.Content>
								<Form onSubmit={this.addNewPhone}>
									<Form.Input
										label={t('token')}
										placeholder={t('companyPagePlaceholder', { query: 'token' })}
										required
										name="token"
										value={token}
										onChange={this.handleFormChange}
									/>
									<Form.Group>
										<Form.Button style={{ marginLeft: 'auto' }} positive type="submit" loading={this.state.loginLoading}>
											<Icon name="checkmark" /> {t('login')}
										</Form.Button>
										<Form.Button color="red" onClick={this.closeDeleteButton}>
											<Icon name="x" /> {t('close')}
										</Form.Button>
									</Form.Group>
								</Form>
							</Modal.Content>
						</Modal>
					</MyMenu>
				</Page>
			);
		}
	}
}

const stateToProps = (state) => ({
	access: state.access,
	location: state.router.location,
	product: state.product.live,
	user: state.access.user.loggedUserObj,
});
export default connect(stateToProps)(withTranslation()(Phones));
